import { config } from '@ps/config';

/** Host + path, lowercased, without the scheme or a trailing slash. */
function normalizeUrl(url: string): string {
  return url
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '')
    .toLowerCase();
}

/**
 * True when `candidate` is the DEFAULT-domain bio-URL snapshot that contact-card
 * setup pre-fills into `websiteUrl1` (`${config.domain}/<urlCode>`). Such a value
 * is "the creator's bio link", not a real external website — so the contact card
 * re-derives it live (custom-domain aware via `bioUrl`) instead of showing the
 * stale snapshot, and setup no longer persists it. A genuine external website
 * (anything else) is left untouched.
 */
export function isBioUrlSnapshot(
  candidate: string | undefined | null,
  urlCode: string,
): boolean {
  if (candidate == null) {
    return false;
  }
  return (
    normalizeUrl(candidate) === normalizeUrl(`${config.domain}/${urlCode}`)
  );
}
